import {BookIcon, PlayIcon, ShieldIcon} from '@primer/octicons-react'

export const resourcesIcons = {
  shield: ShieldIcon,
  book: BookIcon,
  play: PlayIcon,
} as const
